<template>
    <div>
        <b-card no-body class="card-no-border">

            <div class="text-right mb-3">
                <UserAction
                        v-model="dataUser"
                        :options="{ reset: { display: false }, add: { display: true } }">
                </UserAction>
            </div>

            <table class="table table-striped">
                <thead>
                <tr>
                    <th>{{Core.Definition.getDefinition('Liste des réservations')}}</th>
                    <th width="20px"></th>
                </tr>
                </thead>
                <tbody>
                <tr :key="userBookingIndex" v-for="userBooking, userBookingIndex in dataUserBookings">
                    <td>
                        <b-row>
                            <b-col>
                                {{userBooking.user.firstname}} {{userBooking.user.lastname}}<br/>
                                <small>ID: {{userBooking.user.id}}</small>&nbsp;<small>{{userBooking.user.email}}</small>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col v-if="displayEventDateOptions">
                                <InputSelect
                                        :placeholder="Core.Definition.getDefinition('Événement')"
                                        v-model="userBooking.eventDateId"
                                        :options="dataEventDateOptions">
                                </InputSelect>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col lg="8" sm="12">
                                <InputSelect
                                        :placeholder="Core.Definition.getDefinition('État')"
                                        v-model="userBooking.status"
                                        :options="Mantle.EventDateBooking.statusOptions()">
                                </InputSelect>
                            </b-col>
                        </b-row>
                    </td>
                    <td>
                        <b-button class="btn btn-danger btn-sm" @click="onRemoveUserBookingClick(userBookingIndex)"><i class="fa fa-trash-o"></i></b-button>
                    </td>
                </tr>
                <tr v-if="dataUserBookings.length === 0">
                    <td colspan="5">
                        {{Core.Definition.getDefinition('Veuillez sélectionner ou ajouter un ou des utilisateurs.')}}
                    </td>
                </tr>
                </tbody>
            </table>
        </b-card>
    </div>

</template>

<script>
    import Request from './Request'
    import InstanceSelector from './InstanceSelector'
    import InputSelect from './InputSelect'
    import InputText from './InputText'
    import InputPhone from './InputPhone'
    import InputDatePicker from './InputDatePicker'
    import CForm from './CForm'
    import UserAction from './UserAction'
  export default {
      name: 'MultipleUserBooking',
      components: {
          Request,
          InstanceSelector,
          InputSelect,
          InputDatePicker,
          InputText,
          InputPhone,
          CForm,
          UserAction
      },
      props: {
          root: {
              type: String,
              default: ''
          },
          displayEventDateOptions: {
              type: Boolean,
              default: true
          }
      },
      watch: {
          dataUser: {
              handler(val) {
                  this.add(val)
              }
          }
      },
      mounted() {
      },
      data: () => {
          return {
              Core: window.Core,
              Mantle: window.Mantle,
              dataEventId: '',
              dataUserBookings: [],
              dataEventDateOptions: [],
              dataUser: {},
              dataAlert: {
                  message: '',
                  variant: '',
                  show: false
              },
              dataUsers: []
          }
      },
      computed: {
          eventId: {
              set(val) {
                  this.dataEventId = val
              },
              get() {
                  return this.dataEventId
              }
          },
          userBookings: {
              set(val) {
                  this.dataUserBookings = val
              },
              get() {
                  return this.dataUserBookings
              }
          },
          eventDateOptions: {
              set(val) {
                  this.dataEventDateOptions = val
              },
              get() {
                  return this.dataEventDateOptions
              }
          },
          isEmpty() {
              return this.dataUserBookings.length === 0
          },
          isValid() {
              for(let userBooking in this.dataUserBookings) {
                  userBooking = this.dataUserBookings[userBooking]
                  if(!Core.Validation.isId(Core.Select.value(userBooking.eventDateId))) {
                      return false
                  }
                  if (Core.Validation.isEmpty(userBooking.status)) {
                      return false
                  }
              }
              return true
          }
      },
      methods: {
          add(row) {
              if (row.email !== '' || row.firstname !== '') {
                  this.dataUserBookings.push({
                      user: {
                          id: row.id,
                          firstname: row.firstname,
                          lastname: row.lastname,
                          email: row.email,
                          phone: row.phone,
                          birthdate: row.birthdate,
                          mobile: row.mobile,
                      },
                      quantity: 1,
                      eventDateId: null,
                      status: Core.Select.select(Mantle.EventDateBooking.statusRegistered, Mantle.EventDateBooking.statusOptions())
                  })
              }
          },
          onRemoveUserBookingClick(index) {
              this.dataUserBookings.splice(index, 1)
          }
      }
  }
</script>